// src/services/inventairePhotoServices.js
import axios from "axios";

// Compat Vite & CRA
const _base =
  (typeof import.meta !== "undefined" &&
    import.meta.env &&
    import.meta.env.VITE_API_URL) ||
  process.env.REACT_APP_API_URL ||
  "";

const baseUrl = _base.replace(/\/$/, "");

// 🔹 Tes routes serveur sont sous /api/inventaire
const inventaireBase = `${baseUrl}/api/inventaire`;

const authHeaders = () => {
  const token = localStorage.getItem("token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

/**
 * Upload/Remplace la photo d’un objet d’inventaire (local sharp).
 * - POST /api/inventaire/:id/photo?format=webp|jpg|png (défaut webp)
 * - multipart/form-data, champ "file"
 * - Réponse: { ok: true, photo_url: "/uploads/..." }
 */
export const uploadInventairePhoto = async (
  inventaireId,
  file,
  options = {}
) => {
  if (!inventaireId) throw new Error("inventaireId requis");
  if (!file) throw new Error("file requis");

  const { format = "webp", onUploadProgress } = options;

  const form = new FormData();
  form.append("file", file);

  try {
    const { data } = await axios.post(
      `${inventaireBase}/${encodeURIComponent(
        inventaireId
      )}/photo?format=${encodeURIComponent(format)}`,
      form,
      {
        headers: {
          ...authHeaders(),
          // axios gère Content-Type multipart tout seul
        },
        onUploadProgress,
      }
    );
    return data; // { ok:true, photo_url }
  } catch (error) {
    console.error("[uploadInventairePhoto] erreur:", error);
    throw error?.response?.data || error?.message || error;
  }
};

/**
 * (Optionnel) Recadrer/zoomer — si tu ajoutes la route /api/inventaire/:id/crop
 */
export const cropInventairePhoto = async (inventaireId, crop = {}) => {
  if (!inventaireId) throw new Error("inventaireId requis");
  const { x, y, width, height, format, src, outW, outH } = crop;
  const nums = [x, y, width, height];
  if (nums.some((v) => typeof v !== "number" || Number.isNaN(v))) {
    throw new Error("x, y, width, height numériques requis");
  }
  const payload = { x, y, width, height };
  if (format) payload.format = format;
  if (src) payload.src = src;
  if (typeof outW === "number") payload.outW = outW;
  if (typeof outH === "number") payload.outH = outH;

  const { data } = await axios.post(
    `${inventaireBase}/${encodeURIComponent(inventaireId)}/crop`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        ...authHeaders(),
      },
    }
  );
  return data;
};

/**
 * Helper pour <img src="...">
 * - /uploads/... => préfixe par baseUrl (API)
 * - sinon (https://...) => renvoie tel quel
 */
export const toAbsoluteInventairePhotoUrl = (photoUrl) => {
  if (!photoUrl) return "";
  if (photoUrl.startsWith("/uploads/")) {
    return `${baseUrl}${photoUrl}`;
  }
  return photoUrl;
};
